// api 側の Authority 列挙体と値をあわせる必要があります。

export const Authority = {
  /** 権限がありません */
  None: 0,
  /** システム管理者 システム権限 */
  System: 1,
  /** 工務担当者 工務権限 */
  Builder: 2,
  /** 建材部担当者 建材部権限 */
  Material: 3,
  /** 支店担当者 支店権限 */
  Branch: 4,
  /** 業者 業者権限 */
  Supplier: 5
} as const

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Authority = typeof Authority[keyof typeof Authority]
